// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditDashboardFolderModal {
  display: flex;
  flex-direction: column;
  width: 500px;
  padding: 32px;
}
.EditDashboardFolderModal h3 {
  font-weight: 600;
  margin-bottom: 24px;
}
.EditDashboardFolderModal [class^=dist_inputContainer] {
  margin-bottom: 32px;
}
.EditDashboardFolderModal .buttonsSection {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/modules/dashboard/edit-dashboard-folder-modal/edit-dashboard-folder-modal.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AACF;AACE;EACE,gBAAA;EACA,mBAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AADJ","sourcesContent":[".EditDashboardFolderModal {\n  display: flex;\n  flex-direction: column;\n  width: 500px;\n  padding: 32px;\n\n  h3 {\n    font-weight: 600;\n    margin-bottom: 24px;\n  }\n\n  [class^='dist_inputContainer'] {\n    margin-bottom: 32px;\n  }\n\n  .buttonsSection {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
